export default "__VITE_ASSET__DHBj_8N$__"